import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Account, StripePlanRequestPlan } from '@api/types';
import { ModalService } from '@shared/modal/modal.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rav-plan-selection',
  templateUrl: './plan-selection.component.html',
  styleUrls: ['./plan-selection.component.scss']
})
export class PlanSelectionComponent implements OnInit, OnDestroy {
  @Input() plans: any;
  @Input() account: Account;
  selectedPlan: StripePlanRequestPlan;
  modalSubscription: Subscription;

  constructor(public modal: ModalService) {}

  ngOnInit() {
    this.modalSubscription = this.modal.open.subscribe((onOpenData) => {
      if (onOpenData && onOpenData.selectedPlan) this.selectedPlan = onOpenData.selectedPlan;
    });
  }

  ngOnDestroy() {
    this.modalSubscription.unsubscribe();
  }

  /**
   * Determines if monthly plan can be selected
   *
   * @returns true if it can be selected monthly, false if not
   */
  canSelectMonthly(): boolean {
    switch (this.account.subscription_plan) {
      case 'pro.annually':
      case 'basic.annually':
        return false;
      default:
        return true;
    }
  }

  /**
   * Determines if the given plan name is the current plan.
   *
   * @param planName The name of the plan to compare with the current plan
   * @returns true if the planName is the same as the current plan, false if not
   */
  isCurrentPlan(planName: string): boolean {
    return this.account.subscription_plan === planName;
  }
}
